<template>
  <ContainerInfoItem
    source="deal_pipeline_funnel_graph"
    title="Pipeline funnel"
    :description="range.label"
    height="fit-content"
  >
    <SkeletonLoader v-if="isLoading" :page="loaderPages.CHART" />

    <BarChart
      v-else-if="chartCategories && chartData"
      id="deal_pipeline_funnel_graph"
      :categories="chartCategories"
      :series-data="chartData"
    />

    <EmptyScreen
      v-else
      source="deal_pipeline_funnel_graph"
      text="Select a Pipeline"
      :type="emptyScreenTypes.CHART_AND_TABLE"
    />
  </ContainerInfoItem>
</template>

<script setup>
import { computed, onMounted, ref, watchEffect } from "vue";
import store from "@/src/store/index.js";
import BarChart from "@/src/components/charts/BarChart.vue";
import ContainerInfoItem from "@/src/components/info_components/ContainerInfoItem.vue";
import AnalyticService from "@/src/api/AnalyticService.js";
import { emptyScreenTypes } from "@/src/constants/searchConstants.js";
import EmptyScreen from "@/src/components/EmptyScreen.vue";
import { loaderPages } from "@/src/constants/loaderConstants.js";
import SkeletonLoader from "@/src/components/SkeletonLoader.vue";
import { useAnalyticsRefresh } from "@/src/composables/useAnalyticsRefresh.js";

const range = computed(() => store.getters["analytics/getRange"]);
const filters = computed(() => store.getters["analytics/getFilters"]);
const userIds = computed(() => store.getters["analytics/getUserIds"]);
const teamIds = computed(() => store.getters["analytics/getTeamIds"]);

const chartCategories = ref(null);
const chartData = ref(null);
const isLoading = ref(false);

const toFetchDealPipelineFunnel = async () => {
  try {
    isLoading.value = true;

    const params = {
      deal_owner_id: userIds.value,
      team_id: teamIds.value,
      pipeline_id: filters.value?.pipeline?.id,
      start_time: range.value?.start,
      end_time: range.value?.end,
    };

    const response = await AnalyticService.V2.fetchDealPipelineFunnel(params);
    if (response?.success) {
      const data = response?.data?.pipeline_funnel;
      chartCategories.value = data?.map((item) => item?.stage_name || "Stage");
      chartData.value = [
        {
          name: "Deal Count",
          data: data?.map((item) => item.deal_count),
        },
      ];
    }
  } catch (error) {
    console.error(
      "An error occurred while fetching deal pipeline funnel: ",
      error,
    );
  } finally {
    isLoading.value = false;
  }
};

watchEffect(() => {
  if (range.value && userIds.value && teamIds.value)
    toFetchDealPipelineFunnel();
});

useAnalyticsRefresh(toFetchDealPipelineFunnel, [range, userIds, teamIds]);
</script>
